import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Institute } from '@core/model/Institute.model';
import { LoginResponseDto } from '@flamingo/service/flamingo-auth.service';
import { FlamingoHttpService } from '@flamingo/service/flamingo-http.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MainService } from '../main/main.service';
import { LoginDto } from './dto/login.dto';
import { SignupInfoDto } from './dto/signup-info.dto';
import { SignupDto } from './dto/signup.dto';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: FlamingoHttpService,
    private mainService: MainService,
  ) {}

  login(dto: LoginDto): Observable<LoginResponseDto> {
    this.mainService.clearCompanyAndSubscription();
    return this.http.post<LoginResponseDto>('/auth/login', dto);
  }

  registerAccount(dto: SignupDto): Observable<void> {
    return this.http.post<void>('/auth/signup-company', dto);
  }

  signupAccountant(dto: SignupDto): Observable<void> {
    return this.http.post<void>('/auth/signup-accountant', dto);
  }

  resetEmail(username: string): Observable<void> {
    return this.http.post<void>('/auth/reset-code', { username });
  }

  resetCompanyMainUserCode(taxCode: string): Observable<void> {
    return this.http.post<void>('/auth/reset-company-main-user-code', { taxCode });
  }

  checkCode(codeDto: { username: string; code: string }): Observable<void> {
    return this.http.post<void>('/auth/check-code', codeDto);
  }

  activate(activateDto: { username: string; code: string; password: string }): Observable<void> {
    return this.http.post<void>('/auth/activate', activateDto);
  }

  acceptInvitation(id: string | null): Observable<void> {
    if (!id) {
      return of();
    }
    return this.http.post<void>(`/auth/invitation/${id}`);
  }

  getSignupInfo(code: string): Observable<SignupInfoDto> {
    if (!code) {
      return of({});
    }
    const params = new HttpParams().appendAll({ code });
    return this.http.get<SignupInfoDto>(`/auth/signup-info`, params).pipe(catchError(_ => of({})));
  }

  getInstitutes(subtype: string): Observable<Institute[]> {
    const params = new HttpParams().appendAll({ subtype });
    return this.http.get<Institute[]>(`/auth/accountant-institute`, params);
  }
}
